import { render } from "./PortafolioView.vue?vue&type=template&id=c28af2e8&scoped=true"
const script = {}

import "./PortafolioView.vue?vue&type=style&index=0&id=c28af2e8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c28af2e8"]])

export default __exports__